import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const AddLineItemButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      color="primary"
      component={Link}
      to={{
        pathname: `/bill_line_items/create`,
      }}
      state={{
        record: { group_id: record.id },
      }}
    >
      <ButtonIcon /> Add Line Item
    </Button>
  )
}
